import { jsx as l, jsxs as c } from "react/jsx-runtime";
import { clsx as F } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { convertToHtmlId as v } from "../../utils/convert-to-html-id.js";
import { RocheUIGrid as n } from "../grid/roche-grid.js";
import e from "./roche-footer.module.scss.js";
const W = 3, I = (i, s, r) => r && s ? i === 0 ? "right" : i === 1 ? "center" : "left" : s && !r ? i === 0 ? "left" : i === 1 ? "center" : "right" : r ? i === 0 ? "right" : "left" : i === 0 ? "left" : "right", G = ({
  quickLinksTitle: i,
  quickLinks: s,
  footerColumns: r,
  stockPrice: h,
  socialLinksTitle: f,
  socialLinks: m,
  serviceLinksTitle: u,
  serviceLinks: N,
  year: y,
  date: p,
  copyright: g,
  text: k,
  isRightToLeft: a
}) => {
  const t = !!((r == null ? void 0 : r.length) === W && h) ? r == null ? void 0 : r.slice(0, 2) : r == null ? void 0 : r.slice(0, 3), b = (t == null ? void 0 : t.length) === 1, d = !!(((t == null ? void 0 : t.length) || 0) > 1 && h || ((t == null ? void 0 : t.length) || 0) > 2), w = b ? "8-4" : d ? "4-4-4" : "6-6";
  return /* @__PURE__ */ l("footer", { className: F(e.footer, d && e["footer--with-extra-columns"]), children: /* @__PURE__ */ c(n, { layout: "12", noPadding: !0, children: [
    /* @__PURE__ */ l("div", { className: e["footer__first-row"], slot: "full", children: /* @__PURE__ */ c(n, { layout: "3-1-8", fullWidth: !0, isRightToLeft: a, children: [
      /* @__PURE__ */ l(
        "nav",
        {
          className: e["footer__quick-links-nav"],
          "aria-label": i,
          slot: a ? "right" : "left",
          children: /* @__PURE__ */ l("ul", { className: e["footer__quick-links"], children: s })
        }
      ),
      /* @__PURE__ */ l("div", { slot: "center" }),
      /* @__PURE__ */ l("div", { className: e["footer__columns-container"], slot: a ? "left" : "right", children: /* @__PURE__ */ c(n, { layout: w, fullWidth: !0, isRightToLeft: a, children: [
        t == null ? void 0 : t.map((o, _) => /* @__PURE__ */ c(
          "nav",
          {
            "aria-labelledby": v(o.columnTitle),
            slot: I(_, d, a),
            children: [
              /* @__PURE__ */ l("h3", { className: e["footer__column-title"], id: v(o.columnTitle), children: o.columnTitle }),
              /* @__PURE__ */ l("ul", { className: e["footer__column-links"], children: o.links })
            ]
          },
          _
        )),
        h && /* @__PURE__ */ l("div", { className: e["footer__stock-price"], slot: "right", children: h })
      ] }) })
    ] }) }),
    /* @__PURE__ */ l("div", { className: e["footer__second-row"], slot: "full", children: /* @__PURE__ */ c(n, { layout: "4-8", fullWidth: !0, isRightToLeft: a, children: [
      /* @__PURE__ */ l(
        "nav",
        {
          className: e["footer__social-links-nav"],
          "aria-label": f,
          slot: a ? "right" : "left",
          children: /* @__PURE__ */ l("ul", { className: e["footer__social-links"], children: m })
        }
      ),
      /* @__PURE__ */ l("nav", { "aria-label": u, slot: a ? "left" : "right", children: /* @__PURE__ */ l("ul", { className: e["footer__service-links"], children: N }) })
    ] }) }),
    /* @__PURE__ */ l("div", { className: e["footer__third-row"], slot: "full", children: /* @__PURE__ */ c(n, { layout: "4-8", fullWidth: !0, isRightToLeft: a, children: [
      /* @__PURE__ */ c("div", { className: e.footer__copyright, slot: a ? "right" : "left", children: [
        "© ",
        /* @__PURE__ */ l("time", { children: y }),
        "  ",
        g,
        "  ",
        /* @__PURE__ */ l("time", { children: p })
      ] }),
      /* @__PURE__ */ l("div", { className: e["footer__legal-text"], slot: a ? "left" : "right", children: k })
    ] }) })
  ] }) });
};
export {
  G as RocheUIFooter
};
